var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5892 6.94797L8.30984 11.2274C7.64828 11.8889 6.76377 12.3462 5.8437 12.1765C5.34048 12.0837 4.81322 11.8998 4.45756 11.5441C4.1019 11.1884 3.91796 10.6612 3.82514 10.158C3.65543 9.23789 4.11274 8.35338 4.7743 7.69182L8.10863 4.3575C8.90735 3.55877 10.2048 3.13872 11.0036 3.93745C11.8023 4.73618 11.3822 6.03367 10.5835 6.83239L7.57343 9.84245C7.16909 10.2468 6.57665 10.5283 6.07053 10.2621C5.99691 10.2234 5.93036 10.178 5.87703 10.1246C5.82371 10.0713 5.77826 10.0048 5.73956 9.93119C5.47338 9.42507 5.75486 8.83259 6.15922 8.42823L9.05374 5.5337",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/Attachment.98196e94d706294dec3bf85cd53e398e.svg";
export { ForwardRef as ReactComponent };